import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { ANGULARJS_ROOTSCOPE } from "../upgraded-provider/upgraded-providers";

/**
 * Responsável por chamar o serviço que verifica se existe atualização disponível para o nms.
 */
@Injectable({
    providedIn: "root"
})
export class NmsVersionUpdateService {

    private baseUrl: string;

    constructor(private http: HttpClient, @Inject(ANGULARJS_ROOTSCOPE) private $rootScope: any) {
        this.baseUrl = "/products-versions/nms/software-version";
    }

    public storeNmsSoftwareVersion() {
        this.http.get(this.baseUrl).subscribe(
            (response) =>  this.$rootScope.lastNmsVersionAvailable = response
        );
    }
}
